module.exports = __webpack_public_path__ + "static/media/2025 coordination of care.3019e030.pdf";